import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { createUserWithEmailAndPassword, getAuth, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private http: HttpClient
  ) { }

  async loginFirebase(email: any, password: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const auth = getAuth();
      signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        resolve(userCredential);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  async registerFirebase(email: any, password: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const auth = getAuth();
      createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        resolve(userCredential);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  async resetPassword(email: any, password: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const auth = getAuth();
      sendPasswordResetEmail(auth, email)
      .then((userCredential) => {
        resolve(userCredential);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  login(token: string): Observable<any> {
    const loginData = {
      accessToken: token,
      loginType: 'email'
    };
    return this.http.post(environment.baseUrl + '/api/v1/auth/social-login', loginData);
  }

}
